import { defineMessages } from 'react-intl';

export default defineMessages({
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title',
        id: 'help.center.management.sidebar.error.title',
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description',
        id: 'help.center.management.sidebar.error.description',
    },
});
